import styled, { css } from 'styled-components'

interface RectangleButtonProps {
  position: number
  rowSize: number
  tooltipDisable: boolean
}

const rectangleDefaultHeight = 45

export const RectangleButton = styled.button<RectangleButtonProps>`
  position: absolute;
  top: 50%;
  left: ${props => props.position}%;
  width: ${props => props.rowSize}%;
  min-width: 45px;
  height: ${rectangleDefaultHeight}px;
  transform: translateY(-50%);
  /* ${props =>
    props.position <= 50
      ? css` */
        /* `
      : css`
          transform: translate(-100%, -50%);
        `}; */
  border: none;
  border-radius: 6px;
  background: transparent;

  > span {
    height: 100%;
  }

  &:focus {
    filter: drop-shadow(0px 0px 1px #000);
    outline: none;
  }
  &:hover {
    z-index: ${props => (props.tooltipDisable ? 1 : 999)};
  }
`

interface RectangleButtonContentProps {
  behindEllipses: boolean
  backgroundColor: string
}

export const RectangleButtonContent = styled.div<RectangleButtonContentProps>`
  position: relative;
  width: 100%;
  height: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  /* z-index: 0; */

  opacity: ${props => (props.behindEllipses ? 0.2 : 1)};

  svg {
    position: relative;
    pointer-events: none;
    fill: ${({ theme }) => theme.zds.colors.neutral1000};
  }

  .background {
    position: absolute;
    inset: 0;
    background: ${props => props.backgroundColor};
    box-shadow: 0px 4px 4px ${props => props.theme.colors.colorBlack29};
    border-radius: 6px;
    border: 1px solid ${({ theme }) => theme.zds.colors.neutral1000};
    opacity: 1;
  }

  .background:hover {
    filter: brightness(0.8);
  }
`

interface IBadge {
  isAltered?: boolean
  color: string
}

const badgeAlertStyles = css`
  background: ${props => props.theme.colors.colorff0000};
  border: 1.5px solid ${props => props.theme.colors.colorf3f5f9};
  color: ${props => props.theme.colors.colorf3f5f9};
`

const badgeNormalStyles = css<IBadge>`
  background: ${({ theme }) => theme.zds.colors.neutral1000};
  color: ${props => props.color};
`

export const Badge = styled.div<IBadge>`
  position: absolute;
  top: 0;
  right: 5%;
  transform: translateY(-40%);
  height: 20px;
  padding: 0 5px;

  display: flex;
  align-items: center;
  justify-content: center;

  ${({ isAltered }) => (isAltered ? badgeAlertStyles : badgeNormalStyles)}

  border-radius: 4px;

  text-align: center;
  font-weight: 700;
  font-size: 0.875rem;
`
